module.exports = __webpack_public_path__ + "static/img/P1.d84c772.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mssj/P1.png
// module id = aSqx
// module chunks = 0